export default "__VITE_ASSET__bae7d81a__"